export const reducerAppStateName = '@platform/app-state';
